import { render, staticRenderFns } from "./ForumLeftSidebar.vue?vue&type=template&id=3d679b7d&"
import script from "./ForumLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./ForumLeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports